import React from "react";
import AppRouter from "router/router";
import { Box } from "@mui/material";

export default function AppContent() {
  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "hidden" }}>
      <AppRouter />
    </Box>
  );
} 
